import BlogHome from "../Blog/home"
import BubblesBg from "@components/Site/BubblesBg/BubblesBg"
import { usePageContext } from "vike-react/usePageContext"

const BlogPage = () => {
  const pageContext = usePageContext()

  return (
    <div className="relative overflow-hidden">
      <BlogHome key={pageContext?.urlPathname} />
      <BubblesBg/>
    </div>
  )
}

export default BlogPage